import React, { useState } from 'react';
import { Box, Button, Heading, Layer, TextInput } from 'grommet';
import { AddCircle, Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import JobService from '../../api/job-service';

export const AddJobReportRecipientButton = ({
    jobId,
    reportRecipients = [],
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Box>
            <Button
                secondary
                label=<span>
                    <AddCircle size="small" color="enrich-blue" /> Add
                </span>
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <AddJobReportRecipientModal
                    jobId={jobId}
                    reportRecipients={reportRecipients}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const AddJobReportRecipientModal = ({
    jobId,
    reportRecipients = [],
    setShowModal,
}) => {
    const [email, setEmail] = useState('');
    const [buttonBusy, setButtonBusy] = useState();

    const addReportRecipient = async () => {
        try {
            reportRecipients.push(email);
            setButtonBusy(true);

            await new JobService().updateReportRecipients(
                jobId,
                reportRecipients,
            );

            setShowModal(false);
            location.reload();
        } catch (error) {
            console.log(error);
        }

        setButtonBusy(false);
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Add Report Recipient
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <TextInput
                            dropHeight="medium"
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="Email"
                            value={email}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button
                        size="medium"
                        fill="horizontal"
                        primary
                        busy={buttonBusy}
                        disabled={!email.length}
                        label="Add"
                        alignSelf="center"
                        onClick={addReportRecipient}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

AddJobReportRecipientButton.propTypes = {
    jobId: PropTypes.number,
    reportRecipients: PropTypes.arrayOf(PropTypes.string),
};

AddJobReportRecipientModal.propTypes = {
    jobId: PropTypes.number,
    reportRecipients: PropTypes.arrayOf(PropTypes.string),
    setShowModal: PropTypes.func,
};
